import { ENROLLMENT_LOCATION_MESSAGES } from '../../../constants/enrollmentContent'

type LocationSelectionStatusProps = {
  isLoadingLocations: boolean
  isMissingDriverLicenseState: boolean
  isError: boolean
  hasNoLocations: boolean
  hasNoLicenseStateLocations: boolean
  driverLicenseStateName: string
}

export function LocationSelectionStatus({
  isLoadingLocations,
  isMissingDriverLicenseState,
  isError,
  hasNoLocations,
  hasNoLicenseStateLocations,
  driverLicenseStateName
}: LocationSelectionStatusProps) {
  return (
    <>
      {isLoadingLocations ? (
        <div className="rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-900">
          {ENROLLMENT_LOCATION_MESSAGES.loading}
        </div>
      ) : null}

      {isMissingDriverLicenseState ? (
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
          {ENROLLMENT_LOCATION_MESSAGES.missingLicenseState}
        </div>
      ) : null}

      {isError ? (
        <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {ENROLLMENT_LOCATION_MESSAGES.loadFailed}
        </div>
      ) : null}

      {hasNoLocations ? (
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm leading-6 text-amber-900">
          <p className="font-semibold">{ENROLLMENT_LOCATION_MESSAGES.noLocations}</p>
          <p className="mt-1">{ENROLLMENT_LOCATION_MESSAGES.noLocationsHelp}</p>
        </div>
      ) : null}

      {hasNoLicenseStateLocations ? (
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm leading-6 text-amber-900">
          <p className="font-semibold">{ENROLLMENT_LOCATION_MESSAGES.noLicenseStateLocations}</p>
          <p className="mt-1">
            {driverLicenseStateName
              ? `Your driver's license state is ${driverLicenseStateName}. `
              : null}
            {ENROLLMENT_LOCATION_MESSAGES.noLicenseStateLocationsHelp}
          </p>
        </div>
      ) : null}
    </>
  )
}
